import pkg from '../../package.json';

export const environment = {
  title: 'Z2S DEV',
  production: false,
  baseUrl: process.env.BASEURL || 'https://dev-z2s.ru/',
  publicUrl: '',
  apiUrl: 'mobile',
  requestPrefix: 'api/',
  requestParam: 'r',
  version: pkg.version
};
